import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "custom-day-week" }
const _hoisted_3 = { class: "icons" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "custom-month-year-component" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-content-start dp-info"
}
const _hoisted_10 = {
  key: 1,
  class: "row p-2"
}
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex gap-2 justify-content-start align-items-center ps-2 mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiButton = _resolveComponent("AsahiButton")!
  const _component_SolidInfoIcon = _resolveComponent("SolidInfoIcon")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_component_VueDatePicker, {
    modelValue: _ctx.deliveryDate,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.deliveryDate) = $event)),
      _ctx.onDateSelection
    ],
    ref: "vueDatePickerRef",
    "auto-apply": !_ctx.isMobile,
    "action-row": _ctx.actionRow,
    "enable-time-picker": false,
    "month-change-on-scroll": false,
    config: {keepActionRow: false, onClickOutside: false},
    "hide-offset-dates": true,
    "allowed-dates": _ctx.availableDates,
    locale: _ctx.localeValue,
    clearable: false,
    "min-date": _ctx.firstAvailableDate,
    "month-name-format": "long",
    format: "yyyy.MM.dd",
    ui: _ctx.uiOptions,
    "day-class": _ctx.getDayClass,
    markers: _ctx.markers,
    onFocus: _ctx.onCalendarOpen,
    onOpen: _ctx.onCalendarOpen,
    onClosed: _ctx.onCalendarClose,
    onBlur: _ctx.onCalendarClose,
    "teleport-center": _ctx.isMobile,
    class: _normalizeClass([_ctx.isCompact ? 'invert-filter' : '', _ctx.isSavedOrder? 'saved-order':'', _ctx.transparentBackground? 'transparent-background' : '', _ctx.blackVersion ? 'black-version' : ''])
  }, {
    "input-icon": _withCtx(() => [
      (!_ctx.isCompact)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.CalendarIcon
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    "calendar-header": _withCtx(({ index }) => [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.dayOfWeek[index]), 1)
    ]),
    "month-year": _withCtx(({
        month,
        year,
        months,
        handleMonthYearChange
    }) => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: "custom-icon",
          onClick: ($event: any) => (handleMonthYearChange(false))
        }, [
          _createElementVNode("img", { src: _ctx.ChevronLeftIcon }, null, 8, _hoisted_5)
        ], 8, _hoisted_4),
        _createElementVNode("div", _hoisted_6, _toDisplayString(months !== undefined && month !== undefined ? months[month].text : '') + " " + _toDisplayString(year), 1),
        _createElementVNode("span", {
          class: "custom-icon",
          onClick: ($event: any) => (handleMonthYearChange(true))
        }, [
          _createElementVNode("img", { src: _ctx.ChevronRightIcon }, null, 8, _hoisted_8)
        ], 8, _hoisted_7)
      ])
    ]),
    "action-extra": _withCtx(() => [
      (_ctx.isFirstAvailableDateWithFeeSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('calendar notice', { n: _ctx.formattedAvailableDate})), 1))
        : _createCommentVNode("", true),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_AsahiButton, {
                type: "primary",
                class: "w-100",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.saveChanges()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Apply Changes")), 1)
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    "menu-header": _withCtx(() => [
      (_ctx.hasCalendarException)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("span", null, [
              _createVNode(_component_SolidInfoIcon, { fill: "#E17B01" })
            ]),
            _createVNode(_component_AsahiTypography, {
              type: "body-5-regular",
              class: "lh-sm text-start"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Please note when placing an order that delivery days are limited, so we can only deliver your order on the marked days.')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "auto-apply", "action-row", "allowed-dates", "locale", "min-date", "ui", "day-class", "markers", "onFocus", "onOpen", "onClosed", "onBlur", "onUpdate:modelValue", "teleport-center", "class"]))
}